import apiClient, { extractData } from "./client";

export async function getAttendanceRegulations() {
  const response = await apiClient.get("/attendance-regulations");
  return extractData(response);
}

export async function getActiveAttendanceRegulation() {
  const response = await apiClient.get("/attendance-regulations/active");
  return extractData(response);
}

export async function createAttendanceRegulation(data) {
  const response = await apiClient.post("/attendance-regulations", data);
  return extractData(response);
}

export async function updateAttendanceRegulation(id, data) {
  const response = await apiClient.patch(`/attendance-regulations/${id}`, data);
  return extractData(response);
}

export async function activateAttendanceRegulation(id) {
  const response = await apiClient.post(
    `/attendance-regulations/${id}/activate`,
  );
  return extractData(response);
}
